/**
  @param entitlementsByKey
  @param keys The requested entitlement keys
  @returns Entitlements contain true/false for every key (state of is key entitled)
 */
export const getEntitlements = (entitlementsByKey = {}, keys) => keys.reduce((result, key) => [...result, {
  isEntitled: entitlementsByKey[key] || false
}], []);